import { IModalService, IModalServiceInstance } from "angular-ui-bootstrap";
import { IIndicator } from "@gtmhub/error-handling";
import { FileService } from "@gtmhub/files";

interface IPreviewImageData {
  url: string;
}

export class PreviewImageService {
  public static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  public open(url: string): IModalServiceInstance {
    return this.$uibModal.open({
      template: require("./preview-image.html"),
      windowClass: "preview-image-modal",
      backdrop: true,
      controller: "PreviewImageCtrl",
      controllerAs: "$ctrl",
      resolve: {
        previewData: (): IPreviewImageData => ({
          url,
        }),
      },
    });
  }
}

export class PreviewImageCtrl {
  url: string;
  maxHeight: number;
  maxWidth: number;
  indicators: {
    loading?: IIndicator;
  };
  static $inject = ["$uibModalInstance", "FileService", "previewData"];

  constructor(private $uibModalInstance: IModalServiceInstance, private fileService: FileService, private previewData: IPreviewImageData) {
    this.init();
  }

  private init = (): void => {
    this.indicators = {
      loading: { progress: true },
    };

    this.fileService.generateFileUrl(this.previewData.url).then(
      (url) => {
        this.calculateImageDimensions();
        this.url = url;

        delete this.indicators.loading;

        window.addEventListener("resize", this.calculateImageDimensions);
        this.$uibModalInstance.result.finally(() => window.removeEventListener("resize", this.calculateImageDimensions));
      },
      (error) => (this.indicators.loading = { error })
    );
  };

  private calculateImageDimensions = (): void => {
    const defaultModalMargin = 30;
    const modalPadding = 20;
    const bothEndsReduction = 2 * (defaultModalMargin + modalPadding);

    this.maxWidth = document.documentElement.clientWidth - bothEndsReduction;
    this.maxHeight = document.documentElement.clientHeight - bothEndsReduction;
  };
}
